import logEvent from 'analytics/logEvent';
import React from 'react';

import type { menuItems } from 'components/pagesComponents/landing/Main/constants';

import s from './MobuleMenuItem.module.scss';

interface Props {
  item: (typeof menuItems)[0];
}

export default function MenuItem({ item }: Props): JSX.Element {
  const { header, items } = item;
  const subItems = items.map(({ href, text }) => {
    return (
      <a
        key={href}
        href={href}
        className={s.link}
        onClick={(): void => {
          logEvent('Web_Site_Header_Link_Clicked', {
            link_url: href,
          });
        }}
      >
        {text}
      </a>
    );
  });

  return (
    <div>
      <div className={s.header}>{header}</div>

      {subItems}
    </div>
  );
}
